import {
    FILTERING_OPERATORS_FOR_STRING,
    JE_WORKSHEET_TEMPLATE_DASHBOARD_TABLE_COLUMN_NAMES,
    JEWorksheetTemplateTableColumns
} from "src/components/jeAllocation/Constants";
import {JEWorksheet} from "src/models/je-allocation/JEWorksheetList";
import StringUtils from "src/utils/stringUtils";
import React, {useState} from "react";
import CONSTANTS, {JE_ALLOCATION_STATUS_TO_ICON_TYPE} from "src/utils/constants";
import {Link} from "@amzn/awsui-components-react";
import LinkedJEWorksheetModal from "src/components/jeAllocation/worksheet-template/LinkedJEWorksheetModal";
import {StatusIndicator} from "@amzn/awsui-components-react/polaris";

const LinkedWorksheetCell = ({ linkedWorksheets, count }: { linkedWorksheets: JEWorksheet[], count: number }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <>
            <Link
                href="#"
                onFollow={() => {
                    setIsModalOpen(true);
                }}
            >
                {`${count} worksheet${count > 1 ? "s" : ""}`}
            </Link>
            <LinkedJEWorksheetModal
                visible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                linkedWorksheets={linkedWorksheets}
            />
        </>
    );
};

const getCustomPropertiesForWorksheetTemplateTableColumnDefinitions = (column: string) => {
    let cell;
    switch (column) {
        case JE_WORKSHEET_TEMPLATE_DASHBOARD_TABLE_COLUMN_NAMES.TEMPLATE_NAME:
            cell = (e: any) => <Link href={CONSTANTS.PAGE_NAV.JE_ALLOCATION_TEMPLATE.URL + '/' + window.btoa(e.templateId)}>{e[column]}</Link>
            break;
        case JE_WORKSHEET_TEMPLATE_DASHBOARD_TABLE_COLUMN_NAMES.STATUS:
            cell = (e: any) => e[column] !== "" ? <StatusIndicator
                    type={JE_ALLOCATION_STATUS_TO_ICON_TYPE[e[column]]}> {StringUtils.convertCamelCaseToTitleCase(e[column])} </StatusIndicator> : "";
            break;
        case JE_WORKSHEET_TEMPLATE_DASHBOARD_TABLE_COLUMN_NAMES.LINKED_WORKSHEETS:
            cell = (e: any) => {
                const linkedWorksheets = e[column];
                if (!Array.isArray(linkedWorksheets) || linkedWorksheets.length === 0) return "";

                const count = linkedWorksheets.length;
                return (
                    <LinkedWorksheetCell linkedWorksheets={linkedWorksheets} count={count} />
                );
            };
            break;
        default:
            cell = (e: any) => e[column] ?? "";
    }
    return { cell };
};

export const prepareWorksheetTemplateTableColumnDefinitions = () => {
    const columnDefinitions: any[] = [];

    JEWorksheetTemplateTableColumns.forEach((column: string) => {
        columnDefinitions.push({
            id: column,
            header: StringUtils.convertCamelCaseToTitleCase(column),
            sortingField: column,
            width: 300,
            ...getCustomPropertiesForWorksheetTemplateTableColumnDefinitions(column)
        });
    });
    return columnDefinitions;
};


export const getJEWorksheetTemplateDashboardTableFilteringProperties = () => {
    const excludedColumns = ["linkedWorksheets"];

    return JEWorksheetTemplateTableColumns
        .filter((column: string) => !excludedColumns.includes(column))
        .map((column: string) => ({
            propertyLabel: StringUtils.convertCamelCaseToTitleCase(column),
            key: column,
            groupValuesLabel: column,
            operators: FILTERING_OPERATORS_FOR_STRING
        }));
}
